import { useEffect } from "react";
import * as Sentry from "@sentry/react";
var useAddGTM = function (gtmId) {
    useEffect(function () {
        if (process.env.NODE_ENV !== "production")
            return;
        try {
            if (document.getElementById("gtm-script-".concat(gtmId)))
                return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
            var s = document.createElement("script");
            s.async = true;
            s.src = "https://www.googletagmanager.com/gtm.js?id=".concat(gtmId);
            s.id = "gtm-script-".concat(gtmId);
            document.head.appendChild(s);
            var iframe_1 = document.createElement("iframe");
            iframe_1.src = "https://www.googletagmanager.com/ns.html?id=".concat(gtmId);
            iframe_1.setAttribute("height", "0");
            iframe_1.setAttribute("width", "0");
            iframe_1.style.display = "none";
            iframe_1.style.visibility = "hidden";
            var appendIframe = function () {
                document.body && document.body.appendChild(iframe_1);
            };
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", appendIframe, { once: true });
            }
            else {
                appendIframe();
            }
        }
        catch (err) {
            Sentry.captureException(err, { extra: { message: "Failed to load GTM", gtmId: gtmId } });
        }
    }, []);
};
export default useAddGTM;
